import { render, staticRenderFns } from "./verifyLink.vue?vue&type=template&id=84cde4dc&scoped=true&"
import script from "./verifyLink.vue?vue&type=script&lang=js&"
export * from "./verifyLink.vue?vue&type=script&lang=js&"
import style0 from "./verifyLink.vue?vue&type=style&index=0&id=84cde4dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cde4dc",
  null
  
)

export default component.exports